// extracted by mini-css-extract-plugin
export default {"thumb":"NumberSlider_thumb__3LQCh","thumbActive":"NumberSlider_thumbActive__p1TyJ"};